<div class="dialog-content-wrapper" style="margin: -24px;">
    <mat-toolbar matDialogTitle class="mat-indigo-800-bg m-0 customBlue">
      <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
        <span class="title dialog-title"> {{translations.lblDialogHeader}}</span>
        <button mat-button class="mat-icon-button" (click)="dialogRef.close()" aria-label="Close dialog">
          <mat-icon>close</mat-icon>
        </button>
      </mat-toolbar-row>
    </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar style="padding-bottom:0px !important;">

      <form [formGroup]="formGroup" novalidate>
  
      <div fxLayout="row" fxLayoutAlign="start start">
        <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="47">
          <input matInput placeholder="{{translations.lblName}}" formControlName="Name" [(ngModel)]="user.Name" required>
          <mat-error *ngIf="formGroupErrors.Name.required">
              {{translations.msgNameRequired}}
          </mat-error>
        </mat-form-field>
        <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="47">
          <input matInput placeholder="{{translations.lblUsername}}" formControlName="UserName" [(ngModel)]="user.UserName" required>
          <mat-error *ngIf="formGroupErrors.UserName.required">
             {{translations.msgUsernameRequired}}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start start">
        <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="47">
          <input type="email" matInput placeholder="{{translations.lblEmail}}" formControlName="Email" [(ngModel)]="user.Email" required>
          <mat-error *ngIf="formGroupErrors.Email.required">
             {{translations.msgEmailRequired}}
          </mat-error>
          <mat-error *ngIf="formGroupErrors.Email.pattern">
              {{translations.msgEnterValidEmail}}
          </mat-error>
        </mat-form-field>
        <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="47">
          <mat-select placeholder="{{translations.lblLanguage}}" formControlName="LanguageId" [(ngModel)]="user.LanguageId" required>
            <mat-option *ngFor="let language of languageList" [value]="language.Id">{{language.DisplayText}}</mat-option>
          </mat-select>
          <mat-error *ngIf="formGroupErrors.LanguageId.required">
             {{translations.msgLanguageRequired}}
          </mat-error>
        </mat-form-field>
      </div>
	  
	  
      <div fxLayout="row" fxLayoutAlign="start start">
        <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="47">
          <input [type]="!nHide ? 'password' : 'text'" #pass matInput placeholder="{{translations.lblPassword}}" formControlName="Password" [(ngModel)]="user.Password" [readonly]="userId > 0 && !clearInput" required>
          <mat-icon *ngIf="userId <= 0" matSuffix (click)="nHide = !nHide" style="font-size: 15px;">{{nHide ? 'visibility' : 'visibility_off'}}</mat-icon>
          <mat-icon *ngIf="userId > 0 && !clearInput" matSuffix (click)="clearPassword()" style="font-size: 15px;color:orange;cursor: pointer;">edit</mat-icon>
           <mat-icon *ngIf="clearInput" matSuffix (click)="resetPassword()" style="font-size: 15px;color:red;cursor: pointer;">close</mat-icon>
          <mat-error *ngIf="formGroupErrors.Password.required">
             {{translations.msgPasswordRequired}}
          </mat-error>
        </mat-form-field>
        <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="47">
           <input type="text" matInput placeholder="{{translations.lblLastLoginDate}}" formControlName="LastLoginDate" [(ngModel)]="user.LastLoginDate">
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start start" class="user-active-slider">
          <label for="sliderActive" style="float: left;display: inline-block;">{{ translations.lblUserStatus }}</label>
          <mat-slide-toggle style="float: right;display: inline-block;margin-right: 20px;" id="sliderActive" formControlName="IsActive" [checked]="user.IsActive" [(ngModel)]="user.IsActive">
            {{ translations.lblActive }}
          </mat-slide-toggle>
      </div>
    </form>
   
    </div>
     <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="left">
        <button mat-raised-button color="accent" [disabled]="formGroup.invalid" aria-label="SAVE" (click)="save();" fxFlex="47">
            {{translations.btnSave}}
        </button>
        <button mat-raised-button color="warn" aria-label="CLOSE" mat-dialog-close fxFlex="47">
            {{translations.btnCancel}}
        </button>
      </div>
 </div>     


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/user/user-edit-form/user-edit-form.component.html